import "./commentStyle.css";

function Comment({ author, content, initials, light }) {
  return (
    <div className={light ? "lightComment" : "darkComment"}>
      <div className="commentTitle">
        <div className={light ? "lightBubble" : "darkBubble"}>
          <p>{initials}</p>
        </div>
        <h4>{author}</h4>
      </div>
      <div className="commentContent">{content}</div>
    </div>
  );
}

export default Comment;
